import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';

import SearchAlertsToggle from 'dpl/puppy_search_results/components/search_alerts/SearchAlertsToggle';
import { SEARCH_ALERTS_FEATURE_KEY } from 'dpl/puppy_search_results/utils/constants';
import { FOREVER_DURATION, useSnoozed } from 'dpl/shared/hooks/useSnoozed';
import { isGreaterThanBreakpoint, isLessThanBreakpoint } from 'dpl/util/grid';

import useStickyFilters from '../hooks/useStickyFilters';
import CoatTypeFilterButton from './CoatTypeFilterButton';
import ColorFilterButton from './ColorFilterButton';
import ExposedFilterMenu from './ExposedFilterMenu';
import GenderFilterButtons from './GenderFilterButtons';
import SimilarBreedsFilterButton from './SimilarBreedsFilterButton';
import SizeFilterButton from './SizeFilterButton';
import UserLocation from './UserLocation';

const IS_LT_MD = isLessThanBreakpoint('md');
const IS_GT_LG = isGreaterThanBreakpoint('lg');

export default function ExposedFilters({
  className,
  resultsType,
  totalItemCount,
  tabsContainer
}) {
  const { isSnoozed, _ } = useSnoozed();
  const { breedId, emailListJoinedAt } = useSelector(({ server }) => server);
  const containerRef = useRef(null);

  const { stuck } = useStickyFilters({
    container: containerRef.current,
    tabsContainer
  });

  const isToggleHidden =
    isSnoozed(`${SEARCH_ALERTS_FEATURE_KEY}-${breedId}`, FOREVER_DURATION) ||
    emailListJoinedAt;

  return (
    <div
      style={{ top: -1 }}
      ref={containerRef}
      className={classnames(
        'SearchResultsExposedFilters sticky transition z-999',
        stuck ? 'bg-sand bb b--default' : 'bg-white',
        className
      )}
    >
      <div
        className={classnames(
          'flex justify-between items-center gap-12',
          IS_LT_MD ? 'overflow-auto no-scrollbars ph5' : 'container-xxl'
        )}
      >
        <div className="flex flex-wrap gap-12">
          <div className="flex gap-8">
            <SimilarBreedsFilterButton
              resultsType={resultsType}
              totalItemCount={totalItemCount}
            />
            <GenderFilterButtons />
            <SizeFilterButton
              resultsType={resultsType}
              totalItemCount={totalItemCount}
            />
            <CoatTypeFilterButton
              resultsType={resultsType}
              totalItemCount={totalItemCount}
            />
            <ColorFilterButton
              resultsType={resultsType}
              totalItemCount={totalItemCount}
            />
            <ExposedFilterMenu
              resultsType={resultsType}
              totalItemCount={totalItemCount}
            />
          </div>
          {!IS_LT_MD && stuck && <UserLocation className="font-14 secondary" />}
        </div>
        {!isToggleHidden && IS_GT_LG && (
          <SearchAlertsToggle resultsType={resultsType} />
        )}
      </div>
      {(IS_LT_MD || !stuck) && (
        <UserLocation
          className={classnames(
            'font-14 secondary mt3',
            IS_LT_MD ? 'ph5' : 'container-xxl'
          )}
        />
      )}
    </div>
  );
}

ExposedFilters.propTypes = {
  className: PropTypes.string,
  resultsType: PropTypes.string.isRequired,
  totalItemCount: PropTypes.number.isRequired,
  tabsContainer: PropTypes.instanceOf(window.HTMLElement)
};

ExposedFilters.defaultProps = {
  className: null,
  tabsContainer: null
};
